import { render, staticRenderFns } from "./CustomSearchBar.vue?vue&type=template&id=5a700cd6&scoped=true"
import script from "./CustomSearchBar.vue?vue&type=script&lang=js"
export * from "./CustomSearchBar.vue?vue&type=script&lang=js"
import style0 from "./CustomSearchBar.vue?vue&type=style&index=0&id=5a700cd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a700cd6",
  null
  
)

export default component.exports